import { render } from "./MaterialSource.vue?vue&type=template&id=3118f3a8"
import script from "./MaterialSource.vue?vue&type=script&lang=js"
export * from "./MaterialSource.vue?vue&type=script&lang=js"

import "./MaterialSource.vue?vue&type=style&index=0&id=3118f3a8&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__